import React from 'react';
import Error, { ErrorType } from '../src/components/Error';

function NotFound() {
  return <Error type={ErrorType.NOT_FOUND} />;
}

export default NotFound;
